import { useEffect, useState } from "preact/hooks";

import { Calibre } from "./calibre.jsx";
import { Tools1 } from "./tools1.jsx";
import { Tools2 } from "./tools2.jsx";
import { Tools3 } from "./tools3.jsx";
import { Tools4 } from "./tools4.jsx";

const FullscreenIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		stroke-width="2"
	>
		<path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
	</svg>
);

const ExitFullscreenIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		stroke-width="2"
	>
		<path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3" />
	</svg>
);

const CardIcon = () => (
	<svg
		width="100"
		height="100"
		viewBox="0 0 100 100"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z"
			fill="#BD4483"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M50.2424 48.5565C46.933 48.5565 44.2412 45.8647 44.2412 42.5553C44.2412 39.2471 46.933 36.5541 50.2424 36.5541C53.5506 36.5541 56.2436 39.2459 56.2436 42.5553C56.2436 45.8647 53.5506 48.5565 50.2424 48.5565ZM46.793 35.7306V28.6671C46.793 28.213 47.1612 27.8435 47.6165 27.8435H52.8671C53.3224 27.8435 53.6906 28.213 53.6906 28.6671V35.7306C52.6542 35.2047 51.4824 34.9071 50.2424 34.9071C49.0012 34.9071 47.8295 35.2035 46.793 35.7306ZM37.9906 80.1165C37.9095 80.1165 37.8295 80.1047 37.7506 80.08C37.611 80.0377 37.4852 79.959 37.3861 79.8518C37.287 79.7447 37.2184 79.6131 37.1871 79.4706L36.1295 74.6941C36.1012 74.5647 36.1036 74.4318 36.1377 74.3035L38.0236 67.2694H44.813L42.473 76.0012C42.4342 76.1471 42.3553 76.28 42.2459 76.3847L38.5577 79.8894C38.405 80.0353 38.2018 80.1166 37.9906 80.1165ZM49.3977 50.1565L49.18 50.9706H42.3906L43.62 46.38C44.8106 48.4341 46.9295 49.8847 49.3977 50.1565ZM62.493 80.1165C62.2847 80.1165 62.0812 80.0377 61.9259 79.8894L58.2389 76.3847C58.1287 76.2805 58.0497 76.1477 58.0106 76.0012L55.6706 67.2694H62.4612L64.3459 74.3035C64.38 74.4318 64.3824 74.5659 64.3542 74.6941L63.2977 79.4706C63.2567 79.6536 63.1548 79.8172 63.0085 79.9346C62.8623 80.052 62.6805 80.1161 62.493 80.1165ZM51.3036 50.9706L51.0859 50.1565C53.5542 49.8847 55.673 48.4341 56.8636 46.38L58.093 50.9706H51.3036ZM75.5412 65.6224H70.953V60.253C70.953 59.7977 70.5836 59.4294 70.1295 59.4294C69.6742 59.4294 69.3059 59.7977 69.3059 60.253V65.6224H65.9812V61.6953C65.9812 61.24 65.6118 60.8718 65.1577 60.8718C64.7024 60.8718 64.3342 61.24 64.3342 61.6953V65.6224H61.0095V60.253C61.0095 59.7977 60.64 59.4294 60.1859 59.4294C59.7306 59.4294 59.3624 59.7977 59.3624 60.253V65.6224H56.0365V61.6953C56.0365 61.24 55.6683 60.8718 55.2142 60.8718C54.7589 60.8718 54.3895 61.24 54.3895 61.6953V65.6224H51.0659V60.253C51.0659 59.7977 50.6965 59.4294 50.2424 59.4294C49.7871 59.4294 49.4189 59.7977 49.4189 60.253V65.6224H46.0942V61.6953C46.0942 61.24 45.7247 60.8718 45.2706 60.8718C44.8153 60.8718 44.4471 61.24 44.4471 61.6953V65.6224H41.1224V60.253C41.1224 59.7977 40.753 59.4294 40.2989 59.4294C39.8436 59.4294 39.4753 59.7977 39.4753 60.253V65.6224H36.1506V61.6953C36.1506 61.24 35.7812 60.8718 35.3271 60.8718C34.8718 60.8718 34.5036 61.24 34.5036 61.6953V65.6224H31.1789V60.253C31.1789 59.7977 30.8095 59.4294 30.3553 59.4294C29.9 59.4294 29.5318 59.7977 29.5318 60.253V65.6224H24.9424C24.4871 65.6224 24.1189 65.253 24.1189 64.7988V53.4412C24.1189 52.9859 24.4871 52.6177 24.9424 52.6177H75.5412C75.9965 52.6177 76.3647 52.9859 76.3647 53.4412V64.7988C76.3647 65.253 75.9965 65.6224 75.5412 65.6224ZM38.8224 22.4271L42.9459 19.9977C43.2024 19.8459 43.52 19.8459 43.7777 19.9953C44.0353 20.1447 44.1918 20.4224 44.1871 20.72L44.1083 25.48L38.8224 22.4271ZM32.453 47.353C32.313 47.353 32.1706 47.3165 32.0412 47.2424L29.74 45.913L41.3306 25.7777L43.6589 27.1212C43.8478 27.2306 43.9856 27.4104 44.0421 27.6213C44.0985 27.8321 44.069 28.0568 43.96 28.2459L33.1659 46.94C33.0939 47.0655 32.9901 47.1698 32.8649 47.2423C32.7398 47.3148 32.5976 47.353 32.453 47.353ZM28.313 45.0894L25.9918 43.7494C25.8036 43.64 25.6647 43.46 25.6083 43.2494C25.5518 43.0388 25.5812 42.8141 25.6906 42.6247L36.4836 23.9294C36.593 23.7412 36.773 23.6024 36.9836 23.5471C37.1947 23.4901 37.4198 23.5193 37.6095 23.6283L39.9047 24.9541L28.313 45.0894ZM29.7353 51.0024C29.4083 51.0024 29.0859 50.9165 28.8024 50.753L24.5718 48.3106C24.3584 48.1879 24.1714 48.0241 24.0218 47.8286C23.8721 47.6331 23.7628 47.4098 23.7 47.1718C23.5695 46.6883 23.6365 46.1835 23.8859 45.7506L24.5259 44.6412C24.7071 44.853 24.9236 45.0341 25.1683 45.1765L31.2177 48.6683C31.4624 48.8094 31.7271 48.9071 32.0012 48.9577L31.3612 50.0671C31.0283 50.6447 30.4047 51.0024 29.7353 51.0024Z"
			fill="#FEFEFE"
		/>
	</svg>
);

const Ruler = () => (
	<svg
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_46968_7505)">
			<path
				d="M9.54394 17.3103C9.40409 17.1705 9.22591 17.0753 9.03194 17.0367C8.83797 16.9981 8.63692 17.0179 8.4542 17.0936C8.27149 17.1693 8.11532 17.2974 8.00543 17.4619C7.89555 17.6263 7.83689 17.8196 7.83687 18.0174V23.7021C7.83687 23.9673 7.94223 24.2216 8.12977 24.4092C8.3173 24.5967 8.57166 24.7021 8.83687 24.7021H14.5216C14.7193 24.702 14.9127 24.6434 15.0771 24.5335C15.2415 24.4236 15.3697 24.2674 15.4454 24.0847C15.521 23.902 15.5408 23.701 15.5023 23.507C15.4637 23.313 15.3685 23.1349 15.2286 22.995L9.54394 17.3103ZM9.83687 22.7021V20.4316L12.1074 22.7021H9.83687ZM30.9424 28.9896L29.1252 27.1716V1C29.1252 0.734784 29.0198 0.48043 28.8323 0.292893C28.6448 0.105357 28.3904 0 28.1252 0L18.1179 0C17.8527 0 17.5984 0.105357 17.4108 0.292893C17.2233 0.48043 17.1179 0.734784 17.1179 1V15.1647L3.54969 1.59644C3.30302 1.3498 2.98876 1.18185 2.64664 1.11382C2.30452 1.04579 1.94991 1.08074 1.62765 1.21425C1.3054 1.34777 1.02997 1.57384 0.836202 1.86389C0.642434 2.15394 0.539029 2.49493 0.539063 2.84375V31C0.539063 31.2652 0.644419 31.5196 0.831956 31.7071C1.01949 31.8946 1.27385 32 1.53906 32H29.6953C30.0441 32 30.3851 31.8966 30.6751 31.7028C30.9651 31.509 31.1912 31.2335 31.3247 30.9113C31.4582 30.589 31.4931 30.2344 31.425 29.8923C31.357 29.5502 31.189 29.236 30.9424 28.9893L30.9424 28.9896ZM19.1179 2H27.1252V5.71544H22.9689C22.7037 5.71544 22.4494 5.82079 22.2618 6.00833C22.0743 6.19587 21.9689 6.45022 21.9689 6.71544C21.9689 6.98065 22.0743 7.23501 22.2618 7.42254C22.4494 7.61008 22.7037 7.71544 22.9689 7.71544H27.1252V10.8426H24.551C24.2858 10.8426 24.0314 10.948 23.8439 11.1355C23.6564 11.3231 23.551 11.5774 23.551 11.8426C23.551 12.1078 23.6564 12.3622 23.8439 12.5497C24.0314 12.7373 24.2858 12.8426 24.551 12.8426H27.1252V15.9699H22.9689C22.7037 15.9699 22.4494 16.0752 22.2618 16.2628C22.0743 16.4503 21.9689 16.7047 21.9689 16.9699C21.9689 17.2351 22.0743 17.4894 22.2618 17.677C22.4494 17.8645 22.7037 17.9699 22.9689 17.9699H27.1252V25.1716L19.1179 17.1647V2ZM2.53906 30V25.6182H4.85019C5.1154 25.6182 5.36976 25.5128 5.55729 25.3253C5.74483 25.1378 5.85019 24.8834 5.85019 24.6182C5.85019 24.353 5.74483 24.0986 5.55729 23.9111C5.36976 23.7235 5.1154 23.6182 4.85019 23.6182H2.53906V19.3182H4.85019C5.1154 19.3182 5.36976 19.2128 5.55729 19.0253C5.74483 18.8378 5.85019 18.5834 5.85019 18.3182C5.85019 18.053 5.74483 17.7986 5.55729 17.6111C5.36976 17.4235 5.1154 17.3182 4.85019 17.3182H2.53906V13.0182H4.85019C5.1154 13.0182 5.36976 12.9128 5.55729 12.7253C5.74483 12.5378 5.85019 12.2834 5.85019 12.0182C5.85019 11.753 5.74483 11.4986 5.55729 11.3111C5.36976 11.1235 5.1154 11.0182 4.85019 11.0182H2.53906V3.41419L29.1252 30H2.53906Z"
				fill="white"
			/>
		</g>
		<defs>
			<clipPath id="clip0_46968_7505">
				<rect width="32" height="32" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

const Tools1Icon = () => (
	<svg
		width="247"
		height="250"
		viewBox="0 0 247 250"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M0 13.245C0 9.73223 1.39721 6.36331 3.88427 3.87938C6.37133 1.39546 9.74451 0 13.2617 0H233.738C237.255 0 240.629 1.39546 243.116 3.87938C245.603 6.36331 247 9.73223 247 13.245V236.755C247 240.268 245.603 243.637 243.116 246.121C240.629 248.605 237.255 250 233.738 250H13.2617C9.74451 250 6.37133 248.605 3.88427 246.121C1.39721 243.637 0 240.268 0 236.755V13.245ZM233.738 13.245H13.2617V236.755H233.738V13.245Z"
			fill="white"
		/>
		<rect x="8" y="13" width="107" height="227" fill="white" />
	</svg>
);

const Tools2Icon = () => (
	<svg
		width="247"
		height="250"
		viewBox="0 0 247 250"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M0 13.245C0 9.73223 1.39721 6.36331 3.88427 3.87938C6.37133 1.39546 9.74451 0 13.2617 0H233.738C237.255 0 240.629 1.39546 243.116 3.87938C245.603 6.36331 247 9.73223 247 13.245V236.755C247 240.268 245.603 243.637 243.116 246.121C240.629 248.605 237.255 250 233.738 250H13.2617C9.74451 250 6.37133 248.605 3.88427 246.121C1.39721 243.637 0 240.268 0 236.755V13.245ZM233.738 13.245H13.2617V236.755H233.738V13.245Z"
			fill="white"
		/>
		<rect x="65" y="11" width="107" height="227" fill="white" />
	</svg>
);

const Tools3Icon = () => (
	<svg
		width="247"
		height="250"
		viewBox="0 0 247 250"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M0 13.245C0 9.73223 1.39721 6.36331 3.88427 3.87938C6.37133 1.39546 9.74451 0 13.2617 0H233.738C237.255 0 240.629 1.39546 243.116 3.87938C245.603 6.36331 247 9.73223 247 13.245V236.755C247 240.268 245.603 243.637 243.116 246.121C240.629 248.605 237.255 250 233.738 250H13.2617C9.74451 250 6.37133 248.605 3.88427 246.121C1.39721 243.637 0 240.268 0 236.755V13.245ZM233.738 13.245H13.2617V236.755H233.738V13.245Z"
			fill="white"
		/>
		<rect x="66" y="58" width="115" height="115" fill="white" />
	</svg>
);

export function App() {
	const [activeTool, setActiveTool] = useState(-1);
	const [isFullscreen, setIsFullscreen] = useState(false);
	useEffect(() => {
		setActiveTool(1);
		const handler = () => setIsFullscreen(!!document.fullscreenElement);
		document.addEventListener("fullscreenchange", handler);
		return () => document.removeEventListener("fullscreenchange", handler);
	}, []);

	function toggleFullScreen() {
		const ruler = document.getElementById("ruler");
		if (isFullscreen) {
			document.exitFullscreen();
		} else {
			ruler.requestFullscreen().catch((err) => {
				console.error("Fullscreen error:", err);
			});
		}
		window.dispatchEvent(new Event("resize"));
	}

	return (
		<div className="ruler">
			<div className="ruler-tools">
				<button
					style="--btn-color: #1565C0;"
					onClick={toggleFullScreen}
					className="icon-btn full-screen" aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
				>
					{isFullscreen ? <ExitFullscreenIcon /> : <FullscreenIcon />}
				</button>

				<button
					style="--btn-color: #ec9f83;"
					onClick={() => setActiveTool(0)} aria-label="Calibrate ruler with bank card"
					className="tool-btn"
				>
					<CardIcon />
					{/* <span>Calibre</span> */}
				</button>

				<button
					style="--btn-color: #3B945E;"
					className="tools"
					onClick={() => setActiveTool(1)} aria-label="Mark a single point"
				>
					<Ruler />
				</button>

				<button
					style="--btn-color: #AB47BC;"
					className="tools"
					onClick={() => setActiveTool(2)} aria-label="Draw a length from one side"
				>
					<Tools1Icon />
				</button>
				<button
					style="--btn-color: #D16D7F;"
					className="tools"
					onClick={() => setActiveTool(3)} aria-label="Measure length between two points"
				>
					<Tools2Icon />
				</button>
				<button
					style="--btn-color: #36827F;"
					className="tools"
					onClick={() => setActiveTool(4)} aria-label="Draw a rectangular area"
				>
					<Tools3Icon />
				</button>
			</div>
			<div id="ruler-controller"></div>
			<div className="ruler-box">
				{activeTool === 0 && (
					<Calibre onEmit={(event) => event === "close" && setActiveTool(1)} />
				)}
				{activeTool === 1 && <Tools1 />}
				{activeTool === 2 && <Tools2 />}
				{activeTool === 3 && <Tools3 />}
				{activeTool === 4 && <Tools4 />}
			</div>
		</div>
	);
}
